<div mat-dialog-content>
  <p class="h5 text-center">{{message}}</p>
</div>
<div mat-dialog-actions class="d-flex justify-content-center mt-4">
  <button class="btn btn-light mr-2" type="button" (click)="cancel()">Batal</button>
  <button class="btn btn-danger" type="button" (click)="submit()" >Yakin</button>
</div>
